// Native variant links reload the complete product state together (including no-JS visits).
// Enhance only the query string so market, attribution and preview parameters survive.
class PluxyFeedBundleLinks extends HTMLElement {
  connectedCallback() {
    const currentUrl = new URL(window.location.href);
    for (const link of this.querySelectorAll('a[href]')) {
      const destination = new URL(link.href);
      for (const [key, value] of currentUrl.searchParams) {
        if (key === 'variant' || destination.searchParams.has(key)) continue;
        destination.searchParams.append(key, value);
      }
      link.href = destination.href;
    }
  }
}

if (!customElements.get('pluxy-feed-bundle-links')) {
  customElements.define('pluxy-feed-bundle-links', PluxyFeedBundleLinks);
}
